import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import IconArrowBack from '@material-ui/icons/ArrowBack';
import IconEmail from '@material-ui/icons/Email';

import commonStyles from '../common/Styles';

import IconButtonLink from '../common/IconButtonLink';
import IcoTextField from '../common/IcoTextField';
// eslint-disable-next-line
const emailRegexp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

const styles = (theme) => {
  const common = commonStyles(theme);
  return {
    header: {
      lineHeight: '32px',
      display: 'flex',
      '& > a': {
        marginTop: 4,
        marginBottom: 4,
        marginRight: 8,
        width: 24,
        height: 24,
        color: 'inherit',
      },
      '& > h2': {
        fontSize: 24,
        display: 'inline-block',
        fontWeight: 400,
        marginTop: 0,
        // marginBottom: 0,
      }
    },
    form: common.form,
    actionButtons: common.actionButtons,
    notes: {
      margin: 24,
      textAlign: 'left',
      fontWeight: 400,
      fontSize: 14,
      color: 'rgba(0, 0, 0, 0.87)',
      lineHeight: 1.5,
      '&[data-error]': {
        color: theme.palette.error[500],
      },
    },
  };
};

class Recover extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usernameInvalid: true,
      username: '',
      // username: `adam.trojanowski+${Math.round(Math.random() * 1000)}@avalton.com`,
      usernameError: '',
    };
    this.updateState = ({ target: { name, value } }) => {
      this.setState({ [name]: value }, this.validate);
    };
    this.handleBlur = (event) => {
      event.persist();
      const { target: { name }} = event;
      this.setState({  [`${name}Touched`]: true }, () => this.updateState(event));
    };
    this.recover = (event) => {
      const { username } = this.state;
      if (!this.validate() || this.state.inProgress) {
        return;
      }
      this.setState({ inProgress: true, resetError: false });
      event.preventDefault();
      window.AvaCAS.resetPassword({ username })
        .then(
          (data) => {
            this.setState({ afterReset: true });
          },
          (error) => {
            this.setState({ inProgress: false, resetError: true });
          }
        );
    };
    this.validate = () => {
      const usernameInvalid = !this.state.username || !emailRegexp.test(this.state.username);
      const usernameError = usernameInvalid && this.state.usernameTouched ? 'Username must be a valid e-mail address' : '';
      this.setState({ usernameInvalid, usernameError });
      return !usernameInvalid;
    };
  }
  componentDidMount() {
    this.validate();
  }
  render() {
    const { classes } = this.props;
    const { afterReset } = this.state;
    if (afterReset) {
      return ( <Redirect to="/recoverComplete" /> );
    }
    return (
      <div>
        <form
          className={classes.form}>
          <div
            className={classes.header}>
            <IconButtonLink
              to="/"><IconArrowBack /></IconButtonLink>
            <h2>Recover password</h2>
          </div>
          <IcoTextField
            icon={IconEmail}
            ref="username"
            required
            id="username"
            name="username"
            label="Username"
            value={this.state.username}
            type="email"
            margin="normal"
            helperText={this.state.usernameError}
            onBlur={this.handleBlur}
            onChange={this.updateState}
            error={this.state.usernameInvalid && this.state.usernameTouched}
            onKeyDown={(event) => event.key === 'Enter' ? this.login(event) : null }></IcoTextField>
          <p
            className={classes.notes}>{this.props.text}</p>
          { this.state.resetError &&
            ( <p
              data-error={true}
              className={classes.notes}>{this.props.errorText}</p> )
          }
          <div
            className={classes.actionButtons}>
            <span className="to-right">
              { this.state.inProgress && <CircularProgress className="in-progress" size={32} /> }
              <Button
                color="secondary"
                variant="contained"
                disabled={this.state.usernameInvalid || this.state.passwordInvalid || this.state.inProgress}
                onClick={this.recover}>Continue</Button>
            </span>
          </div>
        </form>
      </div>
    );
  }
}

export default withStyles(styles)(Recover)



// WEBPACK FOOTER //
// ./src/components/Recover/index.js